/*=========================================================================================
  File Name: module-taxpapertax.js
  Description: taxpaperTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-taxpaper-state';
import mutations from './module-taxpaper-mutations';
import actions from './module-taxpaper-actions';
import getters from './module-taxpaper-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
